/**
 * Attribute Metrics
 * Spacing tokens come from figma
 * https:www.figma.com/file/s7VxgVsNoO1smpdecnUYoN/Faire-Slate?type=design&node-id=4449-12646&mode=design&t=crJA1bdzBVGLE3uu-0
 */
export var Spacing;
(function (Spacing) {
    Spacing["SPACING_UNKNOWN"] = "SPACING_UNKNOWN";
    Spacing["SPACING_NONE"] = "SPACING_NONE";
    Spacing["XXXS"] = "XXXS";
    Spacing["XXS"] = "XXS";
    Spacing["XS"] = "XS";
    Spacing["S"] = "S";
    Spacing["R"] = "R";
    Spacing["L"] = "L";
    Spacing["XL"] = "XL";
    Spacing["XXL"] = "XXL";
    Spacing["XXXL"] = "XXXL";
})(Spacing || (Spacing = {}));
